(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    class SizeGuideBlock extends HTMLElement {
    connectedCallback() {
      this.rows = JSON.parse(this.querySelector('[data-sg-rows]').textContent || '[]');
      const g = this.querySelector('[data-sg-garment]');
      this.garment = g ? JSON.parse(g.textContent || '[]') : [];
      if (!Array.isArray(this.garment)) this.garment = [];
      this.female = this.dataset.female === 'true';
      this.bustKey = this.female ? 'bust' : 'chest';
      this.dialog = this.querySelector('[data-sg-dialog]');
      this.chipsEl = this.querySelector('[data-sg-chips]');
      this.systemEl = this.querySelector('[data-sg-system]');
      this.unit = this.dataset.unit === 'in' ? 'in' : 'cm';
      this.index = 0;
      this.lastBody = null;

      this.systems = (this.dataset.systems || 'uk').split(',').filter(Boolean);
      if (!this.systems.length) this.systems = ['uk'];
      const stored = localStorage.getItem('sg-system');
      this.system = stored && this.systems.indexOf(stored) > -1 ? stored : this.dataset.system;
      if (this.systems.indexOf(this.system) === -1) this.system = this.systems[0];

      const savedUnit = localStorage.getItem('sg-unit');
      if (savedUnit === 'cm' || savedUnit === 'in') this.unit = savedUnit;

      if (this.systemEl) {
        this.systemEl.value = this.system;
        this.systemEl.addEventListener('change', () => {
          this.system = this.systemEl.value;
          localStorage.setItem('sg-system', this.system);
          this.renderChips();
          if (this.lastBody) this.renderResult(false);
        });
      }

      this.querySelectorAll('[data-sg-unit]').forEach((b) => {
        b.addEventListener('click', () => {
          this.unit = b.dataset.sgUnit;
          localStorage.setItem('sg-unit', this.unit);
          this.paint();
          this.fillSelects();
          if (this.lastBody) this.renderResult(false);
        });
      });

      this.querySelectorAll('[data-sg-tab]').forEach((t) => {
        t.addEventListener('click', () => this.showTab(t.dataset.sgTab));
      });

      this.querySelector('[data-sg-open]').addEventListener('click', () => {
        this.dialog.showModal();
        this.paint();
      });
      this.querySelector('[data-sg-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });

      const submit = this.querySelector('[data-sg-submit]');
      if (submit) submit.addEventListener('click', () => this.recommend());
      const edit = this.querySelector('[data-sg-edit]');
      if (edit) edit.addEventListener('click', () => this.showRecState('form'));

      this.setStretch();
      this.renderChips();
      this.fillSelects();
      this.restoreBody();
    }

    labelFor(s) {
      const key = 'lab' + s.charAt(0).toUpperCase() + s.slice(1);
      return this.dataset[key] || s.toUpperCase();
    }

    showTab(name) {
      this.querySelectorAll('[data-sg-tab]').forEach((t) =>
        t.setAttribute('aria-selected', String(t.dataset.sgTab === name))
      );
      this.querySelectorAll('[data-sg-pane]').forEach((p) => {
        p.hidden = p.dataset.sgPane !== name;
      });
      if (name === 'guide') this.paint();
    }

    showRecState(name) {
      this.querySelectorAll('[data-sg-state]').forEach((s) => {
        s.hidden = s.dataset.sgState !== name;
      });
    }

    setStretch() {
      const el = this.querySelector('.sg__stretch');
      if (!el) return;
      const order = ['non', 'slight', 'medium', 'high'];
      const i = Math.max(0, order.indexOf((el.dataset.stretch || 'non').toLowerCase()));
      const m = el.querySelector('.sg__marker');
      if (m) m.style.left = 'calc(' + (i * 25 + 12.5) + '% - 6px)';
    }

    renderChips() {
      this.chipsEl.innerHTML = '';
      this.rows.forEach((row, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'sg__chip';
        b.textContent = row[this.system] || row.uk || '';
        b.setAttribute('aria-pressed', String(i === this.index));
        b.addEventListener('click', () => { this.index = i; this.paint(); });
        this.chipsEl.appendChild(b);
      });
      this.paint();
    }

    toIn(v) { return (parseFloat(v) / 2.54).toFixed(1); }

    convert(v) {
      if (this.unit === 'cm') return String(v);
      return String(v).split('-').map((n) => this.toIn(n)).join('-');
    }

    convertH(v) {
      if (this.unit === 'cm') return String(v);
      const q = String.fromCharCode(34);
      const a = String.fromCharCode(39);
      return String(v).split('-').map((n) => {
        const total = parseFloat(n) / 2.54;
        let ft = Math.floor(total / 12);
        let rem = Math.round(total - ft * 12);
        if (rem === 12) { ft += 1; rem = 0; }
        return ft + a + rem + q;
      }).join('-');
    }

    fmtHeight(v) {
      if (!v) return '-';
      return this.unit === 'cm' ? v + ' cm' : this.convertH(v);
    }

    sizePill(g) {
      const t = g.querySelector('text');
      const r = g.querySelector('rect');
      if (!t || !r) return;
      let bb;
      try { bb = t.getBBox(); } catch (e) { return; }
      if (!bb || !bb.width) return;
      const svg = g.ownerSVGElement;
      const vb = (svg && svg.getAttribute('viewBox') || '0 0 300 300').split(' ');
      const vbw = parseFloat(vb[2]) || 300;
      const w = Math.max(52, Math.ceil(bb.width) + 24);
      if (!g.dataset.cx) g.dataset.cx = t.getAttribute('x');
      let cx = parseFloat(g.dataset.cx);
      const half = w / 2;
      cx = Math.min(Math.max(cx, half + 2), vbw - half - 2);
      t.setAttribute('x', cx);
      r.setAttribute('width', w);
      r.setAttribute('x', cx - half);
    }

    paint() {
      const row = this.rows[this.index] || {};
      const gRow = this.garment[this.index] || {};
      this.querySelectorAll('[data-sg-unit]').forEach((b) =>
        b.setAttribute('aria-pressed', String(b.dataset.sgUnit === this.unit))
      );
      this.chipsEl.querySelectorAll('.sg__chip').forEach((b, i) =>
        b.setAttribute('aria-pressed', String(i === this.index))
      );
      const suffix = this.unit === 'cm' ? ' cm' : ' in';
      this.querySelectorAll('[data-key]').forEach((el) => {
        const scope = el.closest('[data-sg-src]');
        const source = scope && scope.dataset.sgSrc === 'garment' ? gRow : row;
        const key = el.dataset.key;
        const raw = source[key];
        const isPill = el.tagName.toLowerCase() === 'g';
        const empty = raw === undefined || raw === null || raw === '';
        const isH = key === 'height';
        if (isPill) {
          const t = el.querySelector('text');
          const fb = el.dataset.fallback;
          el.classList.toggle('sg__pill--muted', empty && !!fb);
          if (t) t.textContent = empty ? (fb || '-') : (isH ? this.convertH(raw) : this.convert(raw));
          this.sizePill(el);
        } else {
          el.textContent = empty ? '-' : (isH ? this.fmtHeight(raw) : this.convert(raw) + suffix);
        }
      });
    }

    fillSelects() {
      const bustEl = this.querySelector('[data-sg-bust]');
      const waistEl = this.querySelector('[data-sg-waist]');
      if (!bustEl || !waistEl) return;
      const build = (el, from, to) => {
        const keep = el.value;
        el.innerHTML = '';
        for (let v = from; v <= to; v++) {
          const o = document.createElement('option');
          o.value = String(v);
          o.textContent = this.unit === 'cm' ? v + ' cm' : this.toIn(v) + ' in';
          el.appendChild(o);
        }
        if (keep) el.value = keep;
      };
      build(bustEl, this.female ? 72 : 80, this.female ? 140 : 150);
      build(waistEl, this.female ? 56 : 64, this.female ? 130 : 140);
    }

    restoreBody() {
      const saved = localStorage.getItem('sg-body');
      if (!saved) return;
      try {
        const b = JSON.parse(saved);
        if (!b || !b.bust || !b.waist) return;
        const bustEl = this.querySelector('[data-sg-bust]');
        const waistEl = this.querySelector('[data-sg-waist]');
        if (bustEl) bustEl.value = String(b.bust);
        if (waistEl) waistEl.value = String(b.waist);
        if (bustEl && waistEl) {
          this.lastBody = { bust: parseFloat(b.bust), waist: parseFloat(b.waist) };
          this.renderResult(false);
        }
      } catch (e) { /* ignore */ }
    }

    inRange(val, range) {
      if (!range) return false;
      const p = String(range).split('-').map(parseFloat);
      if (p.length < 2 || isNaN(p[0]) || isNaN(p[1])) return false;
      return val >= p[0] && val <= p[1];
    }

    recommend() {
      const bustEl = this.querySelector('[data-sg-bust]');
      const waistEl = this.querySelector('[data-sg-waist]');
      if (!bustEl || !waistEl) return;
      this.lastBody = { bust: parseFloat(bustEl.value), waist: parseFloat(waistEl.value) };
      localStorage.setItem('sg-body', JSON.stringify(this.lastBody));
      this.renderResult(true);
    }

    renderResult(fromSubmit) {
      const out = this.querySelector('[data-sg-result]');
      const info = this.querySelector('[data-sg-bodyinfo]');
      const tableEl = this.querySelector('[data-sg-table]');
      if (!out || !this.lastBody) return;
      const b = this.lastBody;

      const iB = this.rows.findIndex((r) => this.inRange(b.bust, r[this.bustKey]));
      const iW = this.rows.findIndex((r) => this.inRange(b.waist, r.waist));
      let idx = -1;
      if (iB > -1 && iW > -1) idx = Math.max(iB, iW);
      else if (iB > -1) idx = iB;
      else if (iW > -1) idx = iW;

      if (idx > -1) {
        const row = this.rows[idx];
        const sysSize = this.system.toUpperCase() + ' ' + (row[this.system] || row.uk);
        const shown = row.label ? row.label + ' (' + sysSize + ')' : sysSize;
        out.innerHTML =
          '<div class="sg__result-box"><span class="sg__field-label">' + this.dataset.recLabel + '</span>' +
          '<p class="sg__result-size">' + shown + '</p></div>';
        if (fromSubmit) {
          this.index = idx;
          this.renderChips();
        }
      } else {
        out.innerHTML =
          '<div class="sg__result-box"><b>' + this.dataset.recFail + '</b>' +
          '<p class="sg__result-sub">' + this.dataset.recFailSub + '</p></div>';
      }

      const fmt = (v) => (this.unit === 'cm' ? v + ' cm' : this.toIn(v) + ' in');
      if (info) {
        info.textContent = this.dataset.labelGirth + ': ' + fmt(b.bust) + ', ' +
          this.dataset.labelWaist + ': ' + fmt(b.waist);
      }
      if (tableEl) tableEl.innerHTML = '<div class="sg__table-wrap">' + this.buildTable(idx) + '</div>';
      this.showRecState('result');
    }

    buildTable(highlight) {
      const suffix = this.unit === 'cm' ? ' cm' : ' in';
      const head = [this.dataset.labelCol].concat(this.systems.map((s) => this.labelFor(s)))
        .concat([this.dataset.labelGirth, this.dataset.labelWaist, this.dataset.labelHeight]);
      let html = '<table class="sg__table"><thead><tr>';
      head.forEach((h) => { html += '<th>' + h + '</th>'; });
      html += '</tr></thead><tbody>';
      this.rows.forEach((r, i) => {
        const cell = (v) => (v ? this.convert(v) + suffix : '-');
        const hit = i === highlight ? ' data-hit' : '';
        html += '<tr' + hit + '><td>' + (r.label || '-') + '</td>';
        this.systems.forEach((s) => { html += '<td>' + (r[s] || '-') + '</td>'; });
        html += '<td>' + cell(r[this.bustKey]) + '</td><td>' + cell(r.waist) +
          '</td><td>' + this.fmtHeight(r.height) + '</td></tr>';
      });
      return html + '</tbody></table>';
    }
  }
  if (!customElements.get('size-guide-block')) {
    customElements.define('size-guide-block', SizeGuideBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
